<template>
	<div class="notification-bar" :class="notificationTypeClass">
		<p>{{ notification.message }}</p>
	</div>
</template>

<script>
/** @format */

import {mapActions} from 'vuex';

export default {
	props: {
		notification: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			timeout: null
		};
	},
	mounted() {
		this.timeout = setTimeout(() => this.remove(this.notification), 5000);
	},
	beforeDestroy() {
		clearTimeout(this.timeout);
	},
	computed: {
		notificationTypeClass() {
			return `type-${this.notification.type}`;
		}
	},
	methods: mapActions('notification', ['remove'])
};
</script>

<style lang="scss" scoped>
/** @format */

.notification-bar {
	padding: 10px;
}
.notification-bar.type-info {
	background: #2583ff;
	color: white;
}
.notification-bar.type-error {
	background: red;
	color: white;
}
.notification-bar.type-success {
	background: $forestGreen;
	color: white;
}
</style>
